const CARIBBEAN_ISLANDS = [
  "Antigua",
  "Abaco",
  "Andros",
  "Anguilla",
  "Aruba",
  "Barbuda",
  "Barbados",
  "Bonaire",
  "Curacao",
  "Dominica",
  "Dominican Republic",
  "Eleuthera",
  "Exuma",
  "Grenada",
  "Grand Bahama (Freeport)",
  "Haiti",
  "Jamaica",
  "Montserrat",
  "Nevis",
  "New Providence (Nassau)",
  "Puerto Rico",
  "Saint Lucia",
  "Saint Vincent",
  "Saint Kitts",
  "Trinidad",
  "Tobago",
];

export default CARIBBEAN_ISLANDS;
